/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { VesselPosition } from './VesselPosition';
import {
    VesselPositionFromJSON,
    VesselPositionFromJSONTyped,
    VesselPositionToJSON,
} from './VesselPosition';

/**
 * 
 * @export
 * @interface VesselBasicResult
 */
export interface VesselBasicResult {
    /**
     * 
     * @type {any}
     * @memberof VesselBasicResult
     */
    vesselImoNumber?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselBasicResult
     */
    vesselMmsiNumber?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselBasicResult
     */
    vesselName?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselBasicResult
     */
    activeFlag?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselBasicResult
     */
    flagDate?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselBasicResult
     */
    vesselType?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselBasicResult
     */
    vesselClass?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselBasicResult
     */
    vesselLengthMeters?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselBasicResult
     */
    vesselLengthBetweenPerpendicularsMeters?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselBasicResult
     */
    vesselWidthMeters?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselBasicResult
     */
    vesselDepthMeters?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselBasicResult
     */
    vesselDraught?: any | null;
    /**
     * 
     * @type {VesselPosition}
     * @memberof VesselBasicResult
     */
    lastKnownPosition?: VesselPosition;
    /**
     * 
     * @type {any}
     * @memberof VesselBasicResult
     */
    vesselFreeboardMeters?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselBasicResult
     */
    portCalls?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselBasicResult
     */
    callSign?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselBasicResult
     */
    image?: any | null;
}

/**
 * Check if a given object implements the VesselBasicResult interface.
 */
export function instanceOfVesselBasicResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VesselBasicResultFromJSON(json: any): VesselBasicResult {
    return VesselBasicResultFromJSONTyped(json, false);
}

export function VesselBasicResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): VesselBasicResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'vesselImoNumber': !exists(json, 'vessel_imo_number') ? undefined : json['vessel_imo_number'],
        'vesselMmsiNumber': !exists(json, 'vessel_mmsi_number') ? undefined : json['vessel_mmsi_number'],
        'vesselName': !exists(json, 'vessel_name') ? undefined : json['vessel_name'],
        'activeFlag': !exists(json, 'active_flag') ? undefined : json['active_flag'],
        'flagDate': !exists(json, 'flag_date') ? undefined : json['flag_date'],
        'vesselType': !exists(json, 'vessel_type') ? undefined : json['vessel_type'],
        'vesselClass': !exists(json, 'vessel_class') ? undefined : json['vessel_class'],
        'vesselLengthMeters': !exists(json, 'vessel_length_meters') ? undefined : json['vessel_length_meters'],
        'vesselLengthBetweenPerpendicularsMeters': !exists(json, 'vessel_length_between_perpendiculars_meters') ? undefined : json['vessel_length_between_perpendiculars_meters'],
        'vesselWidthMeters': !exists(json, 'vessel_width_meters') ? undefined : json['vessel_width_meters'],
        'vesselDepthMeters': !exists(json, 'vessel_depth_meters') ? undefined : json['vessel_depth_meters'],
        'vesselDraught': !exists(json, 'vessel_draught') ? undefined : json['vessel_draught'],
        'lastKnownPosition': !exists(json, 'last_known_position') ? undefined : VesselPositionFromJSON(json['last_known_position']),
        'vesselFreeboardMeters': !exists(json, 'vessel_freeboard_meters') ? undefined : json['vessel_freeboard_meters'],
        'portCalls': !exists(json, 'port_calls') ? undefined : json['port_calls'],
        'callSign': !exists(json, 'call_sign') ? undefined : json['call_sign'],
        'image': !exists(json, 'image') ? undefined : json['image'],
    };
}

export function VesselBasicResultToJSON(value?: VesselBasicResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'vessel_imo_number': value.vesselImoNumber,
        'vessel_mmsi_number': value.vesselMmsiNumber,
        'vessel_name': value.vesselName,
        'active_flag': value.activeFlag,
        'flag_date': value.flagDate,
        'vessel_type': value.vesselType,
        'vessel_class': value.vesselClass,
        'vessel_length_meters': value.vesselLengthMeters,
        'vessel_length_between_perpendiculars_meters': value.vesselLengthBetweenPerpendicularsMeters,
        'vessel_width_meters': value.vesselWidthMeters,
        'vessel_depth_meters': value.vesselDepthMeters,
        'vessel_draught': value.vesselDraught,
        'last_known_position': VesselPositionToJSON(value.lastKnownPosition),
        'vessel_freeboard_meters': value.vesselFreeboardMeters,
        'port_calls': value.portCalls,
        'call_sign': value.callSign,
        'image': value.image,
    };
}

